import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faBookOpen} from "@fortawesome/pro-light-svg-icons/faBookOpen";
import {faHouse} from "@fortawesome/pro-light-svg-icons/faHouse";
import {faBagShopping} from "@fortawesome/pro-light-svg-icons/faBagShopping";
import {faUserDoctor} from "@fortawesome/pro-light-svg-icons/faUserDoctor";
import {faUser as faUserLight} from "@fortawesome/pro-light-svg-icons/faUser";

import {faCircleNotch} from "@fortawesome/pro-regular-svg-icons/faCircleNotch";
import {faUser} from "@fortawesome/pro-regular-svg-icons/faUser";
import {faGear} from "@fortawesome/pro-regular-svg-icons/faGear";
import {faReceipt} from "@fortawesome/pro-regular-svg-icons/faReceipt";
import {faCoins} from "@fortawesome/pro-regular-svg-icons/faCoins";
import {faBoxCheck} from "@fortawesome/pro-regular-svg-icons/faBoxCheck";
import {faFaceSunglasses} from "@fortawesome/pro-regular-svg-icons/faFaceSunglasses";
import {faNewspaper} from "@fortawesome/pro-regular-svg-icons/faNewspaper";
import {faCommentQuestion} from "@fortawesome/pro-regular-svg-icons/faCommentQuestion";
import {faStar} from "@fortawesome/pro-regular-svg-icons/faStar";
import {faShieldHeart} from "@fortawesome/pro-regular-svg-icons/faShieldHeart";
import {faTrashXmark} from "@fortawesome/pro-regular-svg-icons/faTrashXmark";

import {faRepeat} from "@fortawesome/pro-solid-svg-icons/faRepeat";
import {faHouse as faHouseSolid} from "@fortawesome/pro-solid-svg-icons/faHouse";
import {faBookOpen as faBookOpenSolid} from "@fortawesome/pro-solid-svg-icons/faBookOpen";
import {faBagShopping as faBagShoppingSolid} from "@fortawesome/pro-solid-svg-icons/faBagShopping";
import {faUserDoctor as faUserDoctorSolid} from "@fortawesome/pro-solid-svg-icons/faUserDoctor";
import {faUser as faUserSolid} from "@fortawesome/pro-solid-svg-icons/faUser";

import Icon from "@/components/Global/Icon/Icon";
import {config} from "@/config";

const {websiteId, isNativeApp} = config;
const isForth = websiteId === 1;
const isEdge = websiteId === 2;
const isBiomarkerTracking = websiteId === 3;
const isWhiteLabelApp = window.config.isWhiteLabelApp;

export const menuRoutes = [
  {
    path: "/",
    icon: <FontAwesomeIcon icon={faHouse} size="2xl" />,
    activeIcon: <FontAwesomeIcon icon={faHouseSolid} size="2xl" />,
    name: "Home",
    className: "",
    show: true,
    showForDemo: true,
    isDesktopOnly: false,
    hasToOpenMenu: false,
  },
  {
    path: "/results",
    icon: <FontAwesomeIcon icon={faCircleNotch} size="2xl" style={{transform: "rotate(180deg)"}} />,
    name: "Results",
    className: "",
    show: true,
    showForDemo: true,
    isDesktopOnly: false,
    hasToOpenMenu: false,
  },
  {
    path: "/plans",
    icon: <Icon icon="plans-icon" className="plansMenuIcon" />,
    name: "Plans",
    show: isForth,
    showForDemo: true,
    isDesktopOnly: false,
  },
  {
    path: "/clinic",
    icon: <FontAwesomeIcon icon={faUserDoctor} size="2xl" />,
    activeIcon: <FontAwesomeIcon icon={faUserDoctorSolid} size="2xl" />,
    name: "Clinic",
    className: "",
    show: isForth,
    showForDemo: true,
    isDesktopOnly: false,
    hasToOpenMenu: false,
  },
  {
    path: isForth
      ? `https://www.forthwithlife.co.uk/health-tests${isNativeApp ? "?external=true" : ""}`
      : `https://www.sportsbloodtests.co.uk/blood-tests${isNativeApp ? "?external=true" : ""}`,
    icon: <FontAwesomeIcon icon={faBagShopping} size="2xl" />,
    activeIcon: <FontAwesomeIcon icon={faBagShoppingSolid} size="2xl" />,
    name: "Shop",
    className: "externalIconShop",
    target: "_blank",
    show: isForth || isEdge,
    showForDemo: true,
    isDesktopOnly: false,
    hasToOpenMenu: false,
  },
  {
    path: "/learn",
    icon: <FontAwesomeIcon icon={faBookOpen} size="2xl" />,
    activeIcon: <FontAwesomeIcon icon={faBookOpenSolid} size="2xl" />,
    name: "Learn",
    className: "",
    show: isForth || isEdge,
    showForDemo: true,
    isDesktopOnly: false,
    hasToOpenMenu: false,
  },
  {
    path: "",
    icon: <FontAwesomeIcon icon={faUserLight} size="2xl" />,
    activeIcon: <FontAwesomeIcon icon={faUserSolid} size="2xl" />,
    name: "Account",
    className: "",
    show: true,
    showForDemo: false,
    isDesktopOnly: true,
    hasToOpenMenu: true,
  },
];

export const myAccountRoutes = [
  {
    path: "health-profile",
    title: "Health Profile",
    icon: faUser,
    description: "Manage your profile information",
    show: true,
  },
  {
    path: "account-settings",
    title: "Account Settings",
    icon: faGear,
    description: "Manage your password, health categories and third party access",
    show: true,
    subRoutes: [
      {
        path: "change-password",
        title: "Change password",
        show: true,
      },
      {path: "manage-health-categories", title: "Manage health categories", show: isForth},
      // {path: "notification-settings", title: "Notification settings"},
      // {path: "insight-settings", title: "Insight settings"},
      // {
      //   path: "doctors-review",
      //   title: "Doctor’s review",
      // },
      {
        path: "third-party",
        title: "Third party access",
        show: true,
      },
      // {
      //   path: "beta-features",
      //   title: "Beta features",
      // },
    ],
  },
  {
    path: "subscriptions",
    title: "Subscriptions",
    icon: faRepeat,
    description: "Stay in control of your subscriptions",
    show: true,
  },
  {path: "order-history", title: "Order History", icon: faReceipt, description: "View your orders", show: true},
  {
    path: "credit",
    title: "Credit & Vouchers",
    icon: faCoins,
    description: "View your credit and vouchers available to you",
    show: isForth || isEdge,
  },
  {
    path: "activate-kit",
    title: "Activate Kit",
    icon: faBoxCheck,
    description: "Got a kit that requires activating?",
    show: true,
  },
  // {path: "upgrade", title: "Upgrade to pro", icon: faUp, description: "Get more insights from £2.99/month"},
  {
    path: "invite",
    title: "Invite Friends & Family",
    icon: faFaceSunglasses,
    description: "Refer friends and earn credit",
    show: isForth || isEdge,
  },
  {
    path: "whats-new",
    title: "What’s New?",
    icon: faNewspaper,
    description: "Keep up to date with our latest updates",
    show: true,
  },
  {
    path: "help",
    title: "Help",
    icon: faCommentQuestion,
    description: "Read our FAQS or contact the team",
    show: isForth || isEdge || (isBiomarkerTracking && !isWhiteLabelApp),
  },
  {
    path: "rate-app",
    title: "Rate the app",
    icon: faStar,
    description: "Tell us what you think!",
    show: isForth || isEdge,
  },
  // {
  //   path: "employee-programme",
  //   title: "Employee Programme",
  //   icon: faBriefcase,
  //   description: "Have you been referred by your employer?",
  //   show: true
  // },
  {
    path: "/tcs-and-privacy",
    title: "T&Cs & Privacy",
    icon: faShieldHeart,
    description: "Stay informed & in control of your data",
    show: true,
    subRoutes: [
      {
        path: "/terms-conditions",
        title: "Terms & Conditions",
        show: true,
      },
      {path: "/privacy-policy", title: "Privacy policy", show: true},
    ],
  },
  {
    path: "/delete",
    title: "Delete My Account",
    icon: faTrashXmark,
    description: "Want to stop tracking your health?",
    show: true,
  },
];
